import type { FC, ReactElement, ReactNode } from 'react';
import { EntityFilterChip } from './EntityFilterChip';

type EntityChipBoundProps = {
  name: string;
  label?: string;
  filter?: Record<string, unknown>;
  isMulti?: boolean;
  width?: number;
  defaultValueLabel?: string;
};

type EntityChipConfig<T> = {
  getOptionLabel: (option: T) => string;
  getOptionValue: (option: T) => string;
  formatOptionLabel?: (option: T) => ReactNode;
  suggestion?: boolean;
  eager?: boolean;
};

export function createEntityFilterChip<T>(url: string, config: EntityChipConfig<T>): FC<EntityChipBoundProps> {
  function BoundEntityFilterChip(props: EntityChipBoundProps): ReactElement {
    return <EntityFilterChip<T> url={url} {...config} {...props} />;
  }
  return BoundEntityFilterChip;
}
